import { initContract } from '@ts-rest/core';
import type { SignupFirstTouch } from './signup-source';

const c = initContract();

export namespace OnboardAuthApi {
    export type VerifyCodeResponse = {
        accessToken: string;
        ownerPhoneNumber: string;
        businessId: number;
        isFirstAccess: boolean;
    };

    export type RefreshResponse = {
        ownerPhoneNumber: string;
        businessId: number;
        accessToken: string;
    };

    export const contract = c.router(
        {
            requestCode: c.mutation({
                method: 'POST',
                path: '/auth/request-code',
                body: c.type<{ phoneNumber: string }>(),
                responses: {
                    204: c.noBody(),
                },
            }),
            verifyCode: c.mutation({
                method: 'POST',
                path: '/auth/verify-code',
                body: c.type<{ phoneNumber: string; code: string; signupSource?: SignupFirstTouch | null }>(),
                responses: {
                    200: c.type<VerifyCodeResponse>(),
                },
            }),
            refresh: c.mutation({
                method: 'POST',
                path: '/auth/refresh',
                body: c.noBody(),
                responses: {
                    200: c.type<RefreshResponse>(),
                },
            }),
            logout: c.mutation({
                method: 'POST',
                path: '/auth/logout',
                body: c.noBody(),
                responses: {
                    204: c.noBody(),
                },
            }),
            transferSession: c.mutation({
                method: 'POST',
                path: '/auth/transfer-session',
                body: c.noBody(),
                responses: {
                    204: c.noBody(),
                },
            }),
        },
        { strictStatusCodes: true },
    );
}
